import { render, staticRenderFns } from "./sendMessageStats.vue?vue&type=template&id=19f6da5a"
import script from "./sendMessageStats.vue?vue&type=script&lang=js"
export * from "./sendMessageStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports